import { MODULE_META } from '../../project-info/members/lib/moduleMeta'

export const ACTIONS = ['VIEW', 'CREATE', 'EDIT', 'DELETE', 'APPROVE', 'EXPORT', 'ADMIN'] as const

export const keyOf = (m: string, a: string) => `${m}:${a}`

// Empty modules are sent too: the server replaces per module, so an empty list
// is what clears a module the admin unchecked.
export const buildRolePermissions = (draft: ReadonlySet<string>) =>
  MODULE_META.map(({ key }) => ({ module: key, actions: ACTIONS.filter((a) => draft.has(keyOf(key, a))) }))
